import React from "react";
import { Router } from "react-router";
import { Route, Switch } from "react-router-dom";
import Auth from "./components/organisms/AuthHOC";
import Login from "./components/pages/LoginPage";
import Message from "./components/pages/Message";
import TalkList from "./components/pages/TalkListPage";
import UserEdit from "./components/pages/UserEdit";
// import { tsConstructorType } from '@babel/types';
import UserList from "./components/pages/UserListPage";
import ContainerProvider from "./containers/ContainerProvider";
import { LoadingContainer } from "./containers/LoadingContainer";
import history from "./history";

import "./stylesheets/main.scss";

const App: React.FC = () => {
  return (
    <Router history={history}>
      <LoadingContainer.Provider>
        <div className="container">
          <Switch>
            <Route exact={true} path="/login" component={Login} />
            <Auth>
              <ContainerProvider>
                <Route exact={true} path="/" component={UserList} />
                <Route exact={true} path="/talks" component={TalkList} />
                <Route exact={true} path="/messages" component={Message} />
                <Route
                  exact={true}
                  path="/users/:user_id/messages"
                  component={Message}
                />
                <Route
                  exact={true}
                  path="/users/:user_id/edit"
                  component={UserEdit}
                />
              </ContainerProvider>
            </Auth>
          </Switch>
        </div>
      </LoadingContainer.Provider>
    </Router>
  );
};

export default App;
